import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
@Injectable({
  providedIn: 'root'
})
export class StoreFinderService {

  constructor(private httpClient:HttpClient, private occEndpointsService:OccEndpointsService) { }

  getLatLong(searchedText){
    return this.httpClient.get("https://nominatim.openstreetmap.org/search?format=json&limit=6&q=" + searchedText)
  }

  getStoreDetails(searchText, lat, long, page){
    
   return this.httpClient.get(this.occEndpointsService.buildUrl(`store/store-finder?locSearchText=${searchText}&latitude=${lat}&longitude=${long}&page=${page}`))
    
  }
}
